export function addAll(target, subarray) {
    target.push.apply(target, subarray);
}
export function removeAll(target, subarray) {
    for (var i = 0; i < subarray.length; i++) {
        var index = target.indexOf(subarray[i]);
        if (index !== -1) {
            target.splice(index, 1);
        }
    }
}
export function toArray(t) {
    return Array.isArray(t) ? t : [t];
}
